<template>
  <div class="page px-3">
    <!-- GINGER-20260629: Kazang V2 merchant-session banner (v1.2.0). Shows the "Start
         session" prompt on mount if no active session, and a live countdown while active.
         Pulls walletId from Vuex selectedWallet — no prop wiring needed. -->
    <!-- GINGER-20260703: Path B manager restriction — gate at mount site. -->
    <!-- GINGER-20260708: gate on user.id == 1 (NOT users.Type). The plan hard-locks this. -->
    <SessionManager v-if="$store.getters.isLoginBoundMerchant" />
    <div class="title d-flex justify-content-between align-items-center">
<!--      <h3 class="m-3 fw-bold">Dashboard</h3>-->
<!--      <div>-->
<!--        <select v-model="selectedWallet" @change="filterCards" class="form-select">-->
<!--          <option value="" disabled>Select Wallet</option>-->
<!--          <option v-for="wallet in user.wallets" :key="wallet.id" :value="wallet.id">-->
<!--            {{ wallet.wallet_name }}-->
<!--          </option>-->
<!--        </select>-->
<!--      </div>-->
    </div>

    <!-- Second Modal -->
    <div class="modal fade" id="secondModal" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1"
         aria-labelledby="staticMainDebtorBackdrop1Label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="secondModalLabel">Deny Request</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-2">
              <label for="Reason" class="fw-bold">Reason</label>
              <input type="text" placeholder="Reason" class="form-control" id="Reason" v-model="reason">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="DenyRequest">Deny</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs for User Requests and Wallet Requests -->
    <div class="tabs">
      <button :class="{'active': activeTab === 'user'}" @click="setTab('user')">User Requests</button>
      <button :class="{'active': activeTab === 'wallet'}" @click="setTab('wallet')">Wallet Requests</button>
    </div>

    <div class="section">
      <div style="width:100%; display:flex; justify-content: space-between; align-items:center">
        <div class="total" style="width: fit-content; display:flex; justify-content: center; align-items:center; gap: 10px">
          <h4 v-if="activeTab === 'wallet'"
              :class="{'attention-required': totalAmount > 0}">
            Total : {{ $utils.formatMoney(totalAmount) }}
          </h4>
          <h4 v-if="activeTab === 'user'"
              :class="{'attention-required': totalAmount > 0}">
            Total : {{ $utils.formatMoney(totalAmount) }}
          </h4>

<!--          <div>-->
<!--            <select v-model="selectedWallet" @change="filterCards" class="form-select">-->
<!--              <option value="" disabled>Select Wallet</option>-->
<!--              <option v-for="wallet in user.wallets" :key="wallet.id" :value="wallet.id">-->
<!--                {{ wallet.wallet_name }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->
        </div>

        <ApproveButton
            buttonText="Batch"
            @click="showApproveModal(); refillVueTable();"
        />
        <!-- GINGER-20260709: #25498 — THE bulk retry button (toolbar). Always visible per Jabulani.
             Default label: "Bulk Retry". Flips to "Retry N Failed" only when N > 0 (the only
             button in the UI that carries the dynamic count). "Retrying..." during operation.
             GINGER-20260709 — disabled condition mirrors the single-row Retry button
             (item.status === 'RETRYING') per Jabulani: "if his not greyed neither should bulk retry". -->
        <button
            class="btn btn-warning"
            :disabled="isRetryingAll"
            @click="retryAllFailed"
        >
          {{ isRetryingAll ? 'Retrying...' : (selectedIds.length > 0 ? `Retry ${selectedIds.length}` : 'Bulk Retry') }}
        </button>
      </div>
      <div class="row gap-1">
        <div class="card col-md-4"
             v-for="(item, index) in filteredCardData"
             :key="index"
        >
          <div>
            <div
                class="manager"
                v-if="item.approved_manager !== null"
            >
              <h6 class="h6-tag">Approved by: {{ item.approved_manager}}</h6>
            </div>
            <div class="d-flex flex-row justify-content-between">
<!--              <button @click="checker(item)">CHECK</button>-->
              <div class="d-flex flex-column mx-3" v-if="item.hasImage">
                <img src="../assets/img/no-image.png" v-gallery
                     :data-large="pettyCashApi+`getImageByRequestID/${item.id}`" alt="Product Image" width="60"
                     height="60"/>
                <span class="text-secondary " style="font-size: 12px">(Click to View)</span>
              </div>
              <div class="d-flex flex-column">
                <span class="text-secondary"><strong>ID:</strong> {{ item.id }}</span>
                <p>{{ item.subType }}</p>
                <p>{{ item.requestedWallet }}</p>
              </div>
              <a @click="acceptRequestOnlyExpense(item)">
                <font-awesome-icon icon="money-bill"/>
              </a>
            </div>
            <div class="product-info">
              <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
              <span v-if="item.reference">{{ item.reference }}<br>({{ item.provider }})</span>
            </div>
          </div>
          <div class="card-body d-flex flex-column">
            <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestBy">{{ item.requestBy }}</span>
            <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
            <span class="card-text mb-1" v-if="activeTab === 'user'"><strong>Department:</strong> {{ item.department }}</span>
            <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
            <span v-if="activeTab === 'user'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
            <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
            <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
            <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.request_date }}</span>
          </div>
          <div class="d-flex flex-row justify-content-evenly">
            <button type="button" class="btn text-center w-50 mx-2 btn-success" @click="AcceptRequest(item)">Accept
            </button>
            <button type="button" class="btn text-center w-50 btn-danger" @click="DenyRequest(item)">Deny</button>
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
                class="btn btn-sm btn-warning w-100"
                :disabled="item.status === 'RETRYING'"
                @click.stop="retryFailedRequest(item)"
            >
              {{ item.status === 'RETRYING' ? 'Retrying...' : 'Retry Payment' }}
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal -->
    <div class="modal fade" id="staticMainDebtorBackdrop1" data-bs-backdrop="false" data-bs-keyboard="false"
         tabindex="-1" aria-labelledby="staticMainDebtorBackdrop1Label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="staticMainDebtorBackdrop1Label">Pay Expense</h6>
            <button type="button" class="btn-close" id="close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="selectedCard">
              <p v-if="activeTab === 'user'"><strong>Subtype:</strong> {{ selectedCard.subType }}</p>
              <p v-if="activeTab === 'user'"><strong>DEPARTMENT:</strong> {{ selectedCard.department }}</p>
              <p><strong>ID:</strong> {{ selectedCard.id }}</p>
              <p><strong>Amount:</strong> {{ selectedCard.amount }}</p>
              <p><strong>Reason:</strong> {{ selectedCard.reason }}</p>
              <p v-if="activeTab === 'user'"><strong>Requested-By:</strong> {{ selectedCard.requestBy }}</p>
              <p v-if="activeTab === 'wallet'"><strong>Requested-By:</strong> {{ selectedCard.requestedBy }}</p>
              <p v-if="activeTab === 'user'"><strong>Phone Number:</strong> {{ selectedCard.reference }}</p>
              <p v-if="activeTab === 'user'"><strong>Date Requested:</strong> {{ selectedCard.requestDate }}</p>
              <p v-if="activeTab === 'wallet'"><strong>Date Requested:</strong> {{ selectedCard.request_date }}</p>
              <button type="button" class="btn btn-primary" @click="viewticket" v-if="selectedCard.type === 'JOBCARD'">
                view Ticket
              </button>
              <button type="button" class="btn btn-primary" @click="openimage">view-image</button>
            </div>
          </div>
          <div class="modal-footer">

          </div>
        </div>
      </div>
    </div>

    <floating-add-button v-if="activeTab === 'user'" @click="showFilterModal"/>
    <MakeWalletRequest v-if="activeTab === 'wallet'" :selectedWallet="selectedWallet" :wallets="wallets"/>


    <button class="hide" id="openCard" data-bs-toggle="modal" data-bs-target="#staticMainDebtorBackdrop1"></button>
    <div v-if="approveAllModal" class="modal-overlay">
      <div class="modal-content form-container">
          <div class="modal-header">
          <!-- GINGER-20260709: #25498 — modal Bulk Retry. Moved to the top of the popup
               (first/leftmost) per Jabulani. Same dynamic label as the toolbar:
               "Bulk Retry" (default) / "Retrying..." (during) / "Retry N Failed" (N>0).
               Always visible, disabled while bulk approve is running OR a bulk retry is in flight.
               GINGER-20260709 — matches single-row Retry logic per Jabulani. -->
          <button
              class="btn btn-warning"
              style="margin-right: 5px"
              :disabled="isLoading || isRetryingAll"
              @click="retryAllFailed"
          >
            {{ isRetryingAll ? 'Retrying...' : (selectedIds.length > 0 ? `Retry ${selectedIds.length}` : 'Bulk Retry') }}
          </button>
          <ApproveButton
              style="margin-right: 5px"
              :buttonText="isLoading ? 'Processing...' : 'Process'"
              :disabled="isLoading"
              @click="approveAll"
          />
          <ApproveButton
              buttonText="Close"
              buttonColor="black"
              hoverColor="#c82333"
              hoverTextColor="#ffffff"
              @click="closeApproveModal"
          />
          <div style="margin-left: 10px">
            <label>
              <input
                  type="checkbox"
                  v-model="selectAll"
                  @change="toggleSelectAll"
              />
              All
            </label>
          </div>
        </div>
        <div class="modal-bodyy">
          <div v-if="isMobileView" class="card-container">
            <div class="card col-md-4"
                 style="width: 100%"
                 v-for="(item, index) in refillTableData"
                 :key="index"
            >
              <div>
                <div
                    class="manager"
                    v-if="item.approved_manager !== null"
                >
                  <h6 class="h6-tag">Approved by: {{ item.approved_manager}}</h6>
                </div>
                <div class="d-flex flex-row justify-content-between">
                  <div class="d-flex flex-column">
                    <p>{{ item.subType }}</p>
                  </div>
                  <div class="d-flex flex-column mx-3">
                    <!-- GINGER-20260711: #25498 (rev 2) — mobile status badge.
                         Uses failedRowIds.has(item.id) as the source of truth
                         (which survives refillVueTable()) so the Failed badge
                         stays correct after the modal refreshes. Success
                         uses item.massage='Success' which the BE/refresh
                         reflects. Per Jabulani's v1.4.25 simplification,
                         we just trust the refetch and BE for the success
                         state instead of tracking an extra Set. -->
                    <span
                        v-if="failedRowIds.has(item.id)"
                        class="badge badge-danger mb-1"
                        style="font-size: 14px; padding: 6px 10px;"
                    >Failed</span>
                    <span
                        v-else-if="item.massage === 'Success'"
                        class="badge badge-success mb-1"
                        style="font-size: 14px; padding: 6px 10px;"
                    >Success</span>
                    <img
                        v-if="item.massage === 'Success'"
                        src="@/assets/img/check.png"
                        alt="Success"
                        class="img"
                    />
                    <img
                        v-else-if="item.massage && item.massage !== 'Success'"
                        src="@/assets/img/cancel.png"
                        alt="Error"
                        class="img"
                    />
                    <button
                        class="btn btn-sm btn-warning mt-1"
                        :disabled="item.status === 'RETRYING'"
                        @click.stop="retryFailedRequest(item)"
                    >
                      {{ item.status === 'RETRYING' ? 'Retrying...' : 'Retry' }}
                    </button>
                  </div>
                  <div class="card-item">
                    <label>
                      <input
                          type="checkbox"
                          :value="item.id"
                          v-model="selectedIds"
                      />
                      Select
                    </label>
                  </div>
                </div>
                <div class="product-info">
                  <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
                </div>
              </div>
              <div class="card-body d-flex flex-column" style="padding: 1px">
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestBy">{{ item.requestBy }}</span>
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
                <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
                <span v-if="activeTab === 'user'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
                <span class="card-text mb-1" v-if="item.massage"><strong>Massage:</strong> {{ item.massage }}</span>
                <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.request_date }}</span>
              </div>
            </div>
          </div>
          <vue-good-table
              v-else
              :columns="columns2"
              :rows="refillTableData"
              @on-selected-rows-change="selectionChanged"
              :search-options="{ enabled: true }"
              :select-options="{ enabled: true }"
              :pagination-options="{ enabled: true, perPage: 6 }"
              class="mt-2"
          >
            <!-- Custom slot for the images column -->
            <template slot="table-row" slot-scope="props">
              <!-- Render images in the custom 'status' column -->
              <td v-if="props.column.field === 'image'">
                <img
                    v-if="props.row.massage === 'Success'"
                    src="@/assets/img/check.png"
                    alt="Success"
                    class="img"
                />
                <img
                    v-else-if="props.row.massage && props.row.massage !== 'Success'"
                    src="@/assets/img/cancel.png"
                    alt="Error"
                    class="img"
                />
                <button
                    class="btn btn-sm btn-warning mt-1"
                    :disabled="props.row.status === 'RETRYING'"
                    @click.stop="retryFailedRequest(props.row)"
                >
                  {{ props.row.status === 'RETRYING' ? 'Retrying...' : 'Retry' }}
                </button>
              </td>
              <!-- Render default content for other columns -->
              <td v-else>
                {{ props.formattedRow[props.column.field] }}
              </td>
            </template>

            <!-- GINGER-20260711: v1.4.25 — removed desktop-only ApproveButton from
               selected-row-actions slot. The modal-header (Bulk Retry +
               Process + Close + All) now shows for both mobile and desktop,
               so this redundant button is no longer needed. -->
            <div slot="selected-row-actions">
            </div>
          </vue-good-table>
          <!-- GINGER-20260711: v1.4.25 — removed standalone desktop Close button
               (modal-header now provides Close for both mobile and desktop). -->
        </div>
        <div class="total-amount" style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">
          Total Amount: {{ $utils.formatMoney(totalSelectedAmount) }}
        </div>
        <div v-if="isLoading" class="overlay">
          <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </section>
        </div>
      </div>
    </div>

    <div v-if="filterModal" class="modal-overlay">
      <div class="modal-content form-container">
        <div class="modal-header" >
          <h3>Select Your Filter Parameters</h3>
        </div>
        <div class="modal-bodyy">
          <div class="filter">
            <select
                class="form-select"
                id="floatingSelect"
                aria-label="Floating label select example"
                v-model="selectedDepartment"
            >
              <option disabled value="" style="margin-top: 10px">Select Department</option>
              <option value="all" style="margin-top: 10px">All Departments</option>
              <option
                  v-for="role in dept"
                  :key="role.id"
                  :value="role.name"
              >
                {{ role.name }}
              </option>
            </select>
            <select
                style="margin: 5px;"
                id="department"
                class="form-control"
                v-model="selectedOffice"
            >
              <option disabled value="" style="margin-top: 10px">Select Office</option>
              <option value="all" style="margin-top: 10px">All Offices</option>
              <option v-for="dept in allOffices" :key="dept.id" :value="dept.name">
                {{ dept.name }}
              </option>
            </select>
          </div>
          <div class="filter">
            <select v-model="selectedWallet" @change="filterCards" class="form-select">
              <option value="" disabled>Select Wallet</option>
              <option v-for="wallet in user.wallets" :key="wallet.id" :value="wallet.id">
                {{ wallet.wallet_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="flexy">
          <ApproveButton
              buttonText="Check Results"
              hoverTextColor="#ffffff"
              @click="closeFilterModal"
          />
          <ApproveButton
              buttonText="Reset"
              hoverTextColor="#ffffff"
              @click="reset"
          />
        </div>
        <div v-if="isLoading" class="overlay">
          <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </section>
        </div>
      </div>
    </div>
<!--    <Filter v-if="activeTab === 'user'" @click="openuser"/>-->
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {VueGoodTable} from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import FloatingAddButton from "@/components/layout/utils/FilterButton.vue";
import {utils as $utils} from "../Services/utils";
import axios from "axios";
import {Storage} from "@/Services/Storage";
import MakeWalletRequest from "@/views/MakeWalletRequest.vue";
import ApproveButton from "@/components/buttons/ApproveButton.vue"
import Filter from '@/components/layout/utils/FilterButton.vue'
// GINGER-20260628: Kazang 2FA OTP prompt. Component lives in components/ but is invoked
// imperatively via DepositOtpPrompt.show({...}) — registration here is just so it's
// discoverable in the components tree.
import DepositOtpPrompt from "@/components/DepositOtpPrompt.vue";
// GINGER-20260629: v1.2.0 merchant-session banner. Renders the active-session countdown
// and the "Start session" prompt on mount. See docs/kazang_v2_session_otp_spec_20260629.md.
import SessionManager from "@/components/SessionManager.vue";

export default {
  name: "UserRequests",
  computed: {
    totalAmount() {
      return this.filteredCardData.reduce((total, card) => total + (card.amount || 0), 0);
    },
    totalSelectedAmount() {
      return this.refillTableData
          .filter(item => this.selectedIds.includes(item.id))
          .reduce((sum, item) => sum + item.amount, 0);
    },
    // GINGER-20260711: #25498 (rev 2) — bulk retry UI. Computed off
    // refillTableData but filtered by failedRowIds (a Set) so the result
    // survives refillVueTable() being called in approveAll()'s finally block
    // (the BE's /getRequestsByWallet wipes row.status back to PENDING because
    // the bulk job is in-memory, so the per-row status is unreliable as a
    // source of truth).
    failedRows() {
      return this.refillTableData.filter(item => this.failedRowIds.has(item.id));
    },
    hasFailedRows() {
      return this.failedRows.length > 0;
    },
    failedCount() {
      return this.failedRows.length;
    },
    $utils() {
      return $utils;
    }
  },
  beforeMount() {
    this.storeSelectedWallet();
    this.getLoggedInUser();
    this.initializeData();

  },
  components: {
    Filter,
    MakeWalletRequest,
    FloatingAddButton,
    ApproveButton,
    VueGoodTable,
    DepositOtpPrompt,
    SessionManager,
  },
  data() {
    return {
      selectedDepartment: 'all',
      selectedOffice: 'all',
      dept: [],
      allOffices: [],
      filterModal: false,
      isLoading: false,
      // GINGER-20260709: #25498 — gates the "Retry All Failed" button so
      // double-clicks don't fire two parallel retry loops.
      isRetryingAll: false,
      // GINGER-20260711: #25498 (rev 2) — preserves failed-row IDs across
      // refillVueTable() (which wipes the optimistic ERROR status on the row
      // because the bulk job lives in BE in-memory state, not in the wallet's
      // pending list). failedRows() reads this Set, so Bulk Retry still finds
      // the failed rows after a modal refresh.
      failedRowIds: new Set(),
      selectAll: false,
      isMobileView: false,
      processingRequests: [],
      mainCards: true,
      massage: '',
      status: false,
      approveAllModal: false,
      showFloatingButton: true, // Controls the visibility of the button
      formData: {},
      activeTab: 'wallet', // Default to 'wallet' tab
      requestsToApprove: [],
      user: {
        Username: 'Null',
        id: 'Null',
        office: '',
        wallets: [],
      },
      reason: '',
      wallets: [],
      selectedWallet: '',
      pettyCashApi: ticketApi2,
      cardData: {
        user: [], // Data for user requests
        wallet: [] // Data for wallet requests
      },
      filteredCardData: [],
      refillTableData: [],
      selectedCard: null,
      denyReason: '', // For storing the reason of denial
      isFetching: false, // Flag to prevent multiple fetches
      sendWallet: '',
      columns2: [
        {label: "ID", field: "id", sortable: true},
        {label: "Type", field: "type", sortable: true},
        {label: "Amount", field: "amount", sortable: true},
        {label: "Approved manager", field: "approved_manager", sortable: true},
        {label: "Reason", field: "reason", sortable: true},
        {label: "Status", field: "status", sortable: true},
        {label: "Massage", field: "massage", sortable: true},
        {label: "State", field: "image", sortable: true},
      ],
      selectedIds: [],
    };
  },
  created() {
    this.getDepartments();
    this.getOffices();
  },
  methods: {
    checker(item) {
      console.log(item);
    },
    showFilterModal() {
      this.filterModal = true;
    },
    closeFilterModal() {
      this.filterCards();
      this.filterModal = false;
    },
    reset() {
      this.selectedDepartment = 'all';
      this.selectedOffice = 'all';
      this.filterCards();
      this.filterModal = false;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Select all IDs
        this.selectedIds = this.refillTableData.map((row) => row.id);
      } else {
        // Deselect all IDs
        this.selectedIds = [];
      }
    },
    processSelected() {
      // Logic for processing selected IDs
      alert(this.selectedIds);
    },
    checkMobileView() {
      this.isMobileView = window.innerWidth <= 768;
    },
    selectionChanged(event) {
      if (event && Array.isArray(event.selectedRows)) {
        this.selectedIds = event.selectedRows.map(row => row.id);
      } else {
        console.error("Unexpected format for selectedRows:", event);
        this.selectedIds = []; // Reset if the input is not valid
      }
    },
    showApproveModal() {
      this.approveAllModal = true;
    },
    closeApproveModal() {
      this.approveAllModal = false;
      // GINGER-20260711 — v1.4.27: refresh BOTH the cards (filteredCardData,
      // which drives the user requests tab behind the modal) AND the
      // vue-good-table data after the modal closes. Per Jabulani: "the list
      // in the user requests tab after processing still doesn't make the
      // call to get Requests after modal is closed". refillVueTable alone
      // wasn't enough — the cards view binds to filteredCardData which is
      // only recomputed by filterCards().
      Promise.all([
        this.filterCards(),
        this.refillVueTable(),
      ]);
    },
    openuser() {
      this.$router.push({name: 'SelectRequest'});

    },
    getOffices() {
      axios.get(`${synergyApi}employee/getOffices`)
          .then(response => {
            this.allOffices = response.data;
            console.log(this.allOffices);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    getDepartments() {
      axios.get(`${synergyApi}employee/getAllDepartments`)
          .then(response => {
            this.dept = response.data; // Ensure this is an array
            console.log(this.dept);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    openwallet() {
      this.$router.push({name: 'wallet'});

    },
    async initializeData() {
      await this.getLoggedInUser(); // Ensure user data is fetched first
      await this.getwallets(); // Call getwallets after user data is set
      this.filterCards(); // Fetch and filter cards based on default tab
    },
    closem() {
      const closeButton = document.getElementById('close');
      if (closeButton) {
        closeButton.click();
      }
    },
    async getwallets() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + 'get-all-wallets');
        this.wallets = response.data;
        console.log('Wallets:', this.wallets);

        // Set the first wallet as the default selected wallet
        if (this.wallets.length > 0) {
          // this.selectedWallet = this.wallets[0].id;
          this.filterCards(); // Fetch and filter cards based on the default wallet
        }
      } catch (error) {
        console.error('Error fetching wallets:', error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    async approveAll() {
      if (this.isLoading) return;
      const selectedData = this.refillTableData.filter(row =>
          this.selectedIds.includes(row.id)
      );
      if (selectedData.length === 0) {
        Swal.fire({
          icon: 'info',
          title: 'No Requests Selected',
          text: 'Please select at least one request to process.',
          confirmButtonText: 'OK'
        });
        return;
      }

      this.isLoading = true;
      try {
        await this.approveAllUsingBulkEndpoint(selectedData);
      } catch (error) {
        if (this.isBulkEndpointUnavailable(error)) {
          await this.approveAllLegacy(selectedData);
        } else {
          return errorHandler.tomcatError(error);
        }
      } finally {
        this.mainCards = true;
        // GINGER-20260711 — #25497 + #25498 (rev 2): refresh the modal so it
        // reflects the latest state after processing. The optimistic per-row
        // status (PROCESSED/ERROR) is now preserved separately in failedRowIds
        // (a Set) so the Bulk Retry button can still find failed rows across
        // this re-fetch. Per Jabulani: "let the user approving decide
        // themselves instead of restricting the buttons on that page" +
        // "when request to approve is done we also need to make sure the
        // modal content is also refreshed".
        // GINGER-20260711 — v1.4.25: also clear selectedIds so processed rows
        // don't appear as selected in the modal table after processing
        // completes. Per Jabulani: "when its done successfully processing its
        // seeing the previously selected rows as selected even when they
        // already processed". failedRowIds Set is preserved so the Failed
        // badge still shows the correct per-row outcome.
        // GINGER-20260711 — v1.4.25 simplification: per Jabulani, trust the
        // refillVueTable() refetch for the success state instead of tracking
        // an extra processedRowIds Set.
        await Promise.all([
          this.filterCards(),
          this.refillVueTable(),
        ]);
        this.selectedIds = [];
        console.log("All API calls completed", this.refillTableData);
        this.isLoading = false;
      }
    },
    async approveAllUsingBulkEndpoint(selectedData) {
      const startUrl = `${ticketApi2}transaction-handler/approve-user-request/bulk`;
      const requestBody = {
        requestIds: selectedData.map(item => item.id),
        approvedBy: this.user.username,
        onlyExpense: false,
        maxParallelism: 4,
      };

      const {data} = await axios.post(startUrl, requestBody);
      const jobId = data?.jobId;
      if (!jobId) {
        throw new Error('Bulk approval did not return a job id.');
      }

      const jobResult = await this.pollBulkApprovalJob(jobId, selectedData);
      if (jobResult?.failed > 0) {
        responses.showInfo(`Bulk processing completed with ${jobResult.failed} failed request(s).`);
      } else {
        responses.showInfo(`Bulk processing completed successfully.`);
      }
    },
    async pollBulkApprovalJob(jobId, selectedData) {
      const statusUrl = `${ticketApi2}transaction-handler/approve-user-request/bulk/${jobId}`;
      const rowMap = new Map(selectedData.map(item => [item.id, item]));
      const maxPolls = 180;

      for (let attempt = 0; attempt < maxPolls; attempt++) {
        const {data} = await axios.get(statusUrl);
        const items = data?.items || [];
        items.forEach(item => this.applyBulkItemStatus(item, rowMap));

        if (data?.status === 'COMPLETED') {
          return data;
        }
        await new Promise(resolve => setTimeout(resolve, 1000));
      }

      throw new Error('Bulk approval job timed out while waiting for completion.');
    },
    applyBulkItemStatus(item, rowMap) {
      const row = rowMap.get(item?.requestId);
      if (!row) {
        return;
      }

      const itemStatus = (item?.status || '').toUpperCase();
      if (itemStatus === 'SUCCESS') {
        row.massage = 'Success';
        row.status = 'PROCESSED';
        this.status = true;
        this.failedRowIds.delete(item.requestId);
        return;
      }

      if (itemStatus === 'FAILED') {
        row.massage = item?.message || 'Failed to process request.';
        row.status = 'ERROR';
        this.failedRowIds.add(item.requestId);
        return;
      }

      if (itemStatus === 'PROCESSING') {
        row.massage = 'Processing...';
        row.status = 'PENDING';
        return;
      }

      row.massage = 'Queued...';
      row.status = 'PENDING';
    },
    async approveAllLegacy(selectedData) {
      const url = `${ticketApi2}transaction-handler/approve-user-request`;
      // GINGER-20260628: handles Kazang 2FA Phase 1 → 202 + OtpRequiredResponse envelope.
      // Backend returns 202 when kill switch is on (kazang.2fa.enabled=true), 200 when off.
      // Phase 1 alone is NOT success — must prompt merchant for OTP and POST to /confirm-otp.
      // GINGER-20260708: inline regen on 401 {reason: session_expired} — see
      // docs/plan_user_id_1_login_session_20260708.md.
      const otpPrompt = this.$options.components?.DepositOtpPrompt || DepositOtpPrompt;
      const prompts = new Set();  // dedupe: only one OTP modal open at a time

      // Helper: inline regen flow for the merchant (id=1). Backend already fired
      // /session/create (silently) — we just need to prompt for OTP, confirm, then
      // retry the original approve. Returns true on success, false if cancelled.
      const tryInlineRegen = async (obj) => {
        try {
          const start = await this.$store.dispatch('regenerateLoginBoundSession');
          if (!start || !start.sessionRequestId) {
            throw new Error('regenerate did not return sessionRequestId');
          }
          const { otp } = await otpPrompt.show({
            phoneHint: start.phoneHint,
            expiresAt: start.expiresAt,
            userRequestId: null,
          });
          await this.$store.dispatch('confirmRegenLoginBoundSession', {
            otp,
            sessionRequestId: start.sessionRequestId,
          });
          return true;
        } catch (e) {
          if (e && e.message === 'cancelled') return false;
          throw e;
        }
      };

      const promises = selectedData.map(async (obj) => {
        const requestBody = {
          id: obj.id,
          approvedBy: this.user.username,
          onlyExpense: false,
          status: 'PENDING',
          errorMessage: "",
        };

        const markError = (e) => {
          requestBody.status = 'ERROR';
          const mainErrorMessage = (e?.message || 'Unknown error').split('\n')[0];
          const shortStackTrace = (e?.stack || '').split('\n').slice(1, 4).join('\n');
          requestBody.errorMessage = `${mainErrorMessage}\n${shortStackTrace}`;
          obj.massage = `${mainErrorMessage}\n${shortStackTrace}`;
          obj.status = 'ERROR';
        };

        try {
          const response = await axios.post(url, requestBody);
          // 2FA Phase 1: backend returned 202 + OtpRequiredResponse
          if (response.status === 202 && response.data?.status === 'OTP_REQUIRED') {
            const envelope = response.data;
            obj.massage = 'Awaiting OTP...';
            obj.status = 'PENDING';
            try {
              // Show modal. If another OTP modal is already open, wait for it then re-prompt.
              while (prompts.has(obj.id)) {
                await new Promise(r => setTimeout(r, 250));
              }
              prompts.add(obj.id);
              const { otp } = await otpPrompt.show({
                phoneHint: envelope.phoneHint,
                expiresAt: envelope.expiresAt,
                userRequestId: obj.id,
              });
              prompts.delete(obj.id);
              // Phase 2: POST OTP to /confirm-otp
              await this.$store.dispatch('confirmOtpForUserRequest', {
                userRequestId: obj.id,
                otp,
              });
              requestBody.status = 'PROCESSED';
              obj.massage = 'Success';
              obj.status = 'PROCESSED';
              this.status = true;
            } catch (promptErr) {
              prompts.delete(obj.id);
              if (promptErr.message === 'cancelled') {
                // User cancelled OTP — leave request PENDING, they can retry the approve later
                obj.massage = 'OTP cancelled';
                obj.status = 'PENDING';
              } else {
                markError(promptErr);
              }
            }
          } else {
            // Legacy 200 path (kill switch off) — original success behavior
            requestBody.status = 'PROCESSED';
            obj.massage = 'Success';
            obj.status = 'PROCESSED';
            this.status = true;
          }
        } catch (error) {
          // GINGER-20260708: inline regen — if the merchant's login-bound session
          // hard-expired mid-approval, the backend returns 401 with body
          // {reason: "session_expired", prompt: "..."}. Fire the regen flow once,
          // then retry this approve. Single retry — if it fails again, surface error.
          const respData = error?.response?.data;
          const isExpiredSession =
            error?.response?.status === 401
            && respData
            && (respData.reason === 'session_expired'
                || (typeof respData === 'string' && respData.includes('session_expired')));
          if (isExpiredSession) {
            try {
              obj.massage = 'Session expired — renewing…';
              obj.status = 'PENDING';
              const regenOk = await tryInlineRegen(obj);
              if (!regenOk) {
                obj.massage = 'Renewal cancelled';
                obj.status = 'PENDING';
                return;
              }
              // Retry the approve. The backend now has a fresh sessionId.
              const retry = await axios.post(url, requestBody);
              if (retry.status === 202 && retry.data?.status === 'OTP_REQUIRED') {
                // Should not happen for id=1 (session-based, no per-deposit OTP),
                // but handle defensively.
                obj.massage = 'Awaiting OTP...';
                obj.status = 'PENDING';
              } else {
                requestBody.status = 'PROCESSED';
                obj.massage = 'Success';
                obj.status = 'PROCESSED';
                this.status = true;
              }
              return;
            } catch (regenErr) {
              markError(regenErr);
              return;
            }
          }
          try {
            errorHandler.tomcatError(error, true);
          } catch (e) {
            markError(e);
          }
        }
      });

      await Promise.all(promises);
    },
    // GINGER-2026-04-03: Retry failed payment with new local_id
    // TICKET: Founder escalation — users can't retry failed Kazang payments since Mar 26
    // ENDPOINT: POST /transaction-handler/approve-user-request with forceNewLocalId: true
    // GINGER-20260709: #25498 — added inline 401 session_expired regen (copied pattern
    // from approveAllLegacy:759-883) so bulk retry survives the merchant session boundary.
    async retryFailedRequest(item) {
      item.status = 'RETRYING';
      item.massage = 'Retrying with new Local ID...';
      const url = `${ticketApi2}transaction-handler/approve-user-request`;
      const buildBody = () => ({
        id: item.id,
        approvedBy: this.user.username,
        onlyExpense: false,
        forceNewLocalId: true,
      });
      const otpPrompt = this.$options.components?.DepositOtpPrompt || DepositOtpPrompt;
      // Inline regen for the merchant (id=1). Mirrors approveAllLegacy:759-779.
      const tryInlineRegen = async () => {
        const start = await this.$store.dispatch('regenerateLoginBoundSession');
        if (!start || !start.sessionRequestId) {
          throw new Error('regenerate did not return sessionRequestId');
        }
        const { otp } = await otpPrompt.show({
          phoneHint: start.phoneHint,
          expiresAt: start.expiresAt,
          userRequestId: null,
        });
        await this.$store.dispatch('confirmRegenLoginBoundSession', {
          otp,
          sessionRequestId: start.sessionRequestId,
        });
      };
      try {
        await axios.post(url, buildBody());
        item.massage = 'Success';
        item.status = 'PROCESSED';
        this.status = true;
        this.failedRowIds.delete(item.id);
        responses.showSuccess('Payment retried successfully!');
      } catch (error) {
        // 401 session_expired — fire regen flow once, then retry the approve.
        const respData = error?.response?.data;
        const isExpiredSession =
          error?.response?.status === 401
          && respData
          && (respData.reason === 'session_expired'
              || (typeof respData === 'string' && respData.includes('session_expired')));
        if (isExpiredSession) {
          try {
            item.massage = 'Session expired — renewing…';
            item.status = 'PENDING';
            await tryInlineRegen();
            // Retry the approve with a fresh sessionId.
            await axios.post(url, buildBody());
            item.massage = 'Success';
            item.status = 'PROCESSED';
            this.status = true;
            this.failedRowIds.delete(item.id);
            responses.showSuccess('Payment retried successfully!');
            return;
          } catch (regenErr) {
            if (regenErr && regenErr.message === 'cancelled') {
              item.massage = 'Renewal cancelled';
              item.status = 'ERROR';
              this.failedRowIds.add(item.id);
              return;
            }
            const msg = (regenErr?.message || 'Unknown error').split('\n')[0];
            item.massage = msg;
            item.status = 'ERROR';
            this.failedRowIds.add(item.id);
            responses.showWarning('Retry failed: ' + msg);
            return;
          }
        }
        try {
          errorHandler.tomcatError(error, true);
        } catch (e) {
          const msg = e.message.split('\n')[0];
          item.massage = msg;
          item.status = 'ERROR';
          this.failedRowIds.add(item.id);
          responses.showWarning('Retry failed: ' + msg);
        }
      }
    },
    // GINGER-20260711 — BULK-RETRY-SELECTED: Bulk Retry now operates on selectedIds,
    // exactly mirroring how approveAll() / Process uses the same selectedIds. Per
    // Jabulani: "bulk retry uses selected requests just like process" — the user
    // picks which rows to retry, same as they pick which rows to approve.
    // failedRowIds Set is RETAINED — it's still used by the mobile modal badge
    // (Failed/Success label) as the source of truth for per-row outcome.
    // v1.4.23 follow-up: removed refillVueTable() between batches (was wiping
    // the optimistic PROCESSED/ERROR that retryFailedRequest sets on each row,
    // making the bulk retry look like a no-op — rows just visually unchecked
    // with no other feedback). Also stopped auto-clearing selectedIds at the
    // end so the user can see what was retried; vue-good-table's UI now keeps
    // the just-retried rows checked, mirroring Process behaviour.
    async retryAllFailed() {
      if (this.isRetryingAll) return;
      const selectedRows = this.refillTableData.filter(item => this.selectedIds.includes(item.id));
      if (selectedRows.length === 0) {
        responses.showInfo('No requests selected to retry. Tick the rows you want to retry, then click Bulk Retry.');
        return;
      }
      this.isRetryingAll = true;
      const cap = 4;
      let successCount = 0;
      let failCount = 0;
      try {
        for (let i = 0; i < selectedRows.length; i += cap) {
          const batch = selectedRows.slice(i, i + cap);
          const results = await Promise.allSettled(batch.map(row => this.retryFailedRequest(row)));
          results.forEach(r => {
            if (r.status === 'fulfilled') successCount++;
            else failCount++;
          });
        }
        // One single refill at the end — preserves the optimistic per-row
        // PROCESSED/ERROR the whole way through the batch loop, then refreshes
        // once to pick up whatever the BE now reports.
        await this.refillVueTable();
        console.log(`[GINGER-20260711] Bulk Retry complete: ${successCount} succeeded, ${failCount} failed (of ${selectedRows.length} selected)`);
        if (failCount === 0) {
          responses.showSuccess(`Bulk Retry complete — ${successCount} ${successCount === 1 ? 'request' : 'requests'} retried successfully.`);
        } else if (successCount === 0) {
          responses.showWarning(`Bulk Retry failed for all ${failCount} ${failCount === 1 ? 'request' : 'requests'}.`);
        } else {
          responses.showWarning(`Bulk Retry partial — ${successCount} succeeded, ${failCount} failed.`);
        }
        // GINGER-20260711 — v1.4.25: clear selectedIds after bulk retry so the
        // Bulk Retry button label resets to "Bulk Retry" instead of staying
        // on "Retry N". Per Jabulani: "retry button still shows Retry N even
        // after processing / retrying, like selected list not cleared".
      } finally {
        this.selectedIds = [];
        this.isRetryingAll = false;
      }
    },
    isBulkEndpointUnavailable(error) {
      const statusCode = error?.response?.status;
      return statusCode === 404 || statusCode === 405;
    },
    async AcceptRequest(selectedCard) {
      const id = selectedCard.id; // Get the selected request ID
      const approvedBy = this.user.username;
      // Determine the URL based on the active tab
      const url = this.activeTab === 'wallet'
          ? `${ticketApi2}transaction-handler/approve-wallet-request`
          : `${ticketApi2}transaction-handler/approve-user-request`;

      const requestBody = {
        id: id,
        approvedBy: approvedBy,
        onlyExpense: false
      };
      let recipient = selectedCard.requestBy ? selectedCard.requestBy : selectedCard.requestedBy;
      return Swal.fire({
        title: 'Are you sure?',
        text: `You are about to authorize ${$utils.formatMoney(selectedCard.amount)} payment to ${recipient}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async () => {
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Approved Successfully`);
            // GINGER-20260709 — #25497: refresh table view too
            return Promise.all([
              this.filterCards(),
              this.refillVueTable()
            ]); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Accept Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;
              return Swal.showValidationMessage('<pre>' + formattedError + '</pre>');
            }
          }
        }
      })
    },


    storeSelectedWallet() {
      if (this.selectedWallet) {
        // localStorage.setItem('selectedWallet', this.selectedWallet);
        this.$store.commit(`setSelectedWallet`, this.selectedWallet)
      }
    },
    async DenyRequest(selectedCard) {
      return Swal.fire({
        icon: `question`,
        title: `Deny Reason`,
        input: `textarea`,
        showCloseButton: true,
        showCancelButton: true,
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async (inputValue) => {
          if (!inputValue) return Swal.showValidationMessage(`Reason is Required`);
          const id = selectedCard.id;
          const type = this.activeTab === 'wallet' ? 'WALLET' : 'USER';
          const declinedBy = this.user.username;
          const url = `${ticketApi2}decline`;

          const requestBody = {
            id: id,
            type: type,
            reason: inputValue,
            declinedBy: declinedBy
          };
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Declined Successfully`);
            // GINGER-20260709 — #25497: refresh table view too
            return Promise.all([
              this.filterCards(),
              this.refillVueTable()
            ]); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Decline Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;

              // Display the formatted error message in SweetAlert
              return Swal.showValidationMessage(formattedError);
            }
          }
        }
      })
    },
    async viewticket(selectedCard) {
      const ticket = selectedCard.ticket;
      return window.open(`https://hd.chrilantech.com/ticket/${ticket}`)
    },
    async showPhoto(selectedCard) {
      return window.open(ticketApi2 + `getImageByRequestID/${selectedCard.id}`)
    },
    async acceptRequestOnlyExpense(selectedCard) {
      const id = selectedCard.id; // Get the selected request ID
      const approvedBy = this.user.username;
      // Determine the URL based on the active tab
      const url = this.activeTab === 'wallet'
          ? `${ticketApi2}transaction-handler/approve-wallet-request`
          : `${ticketApi2}transaction-handler/approve-user-request`;

      const requestBody = {
        id: id,
        approvedBy: approvedBy,
        onlyExpense: true
      };
      let recipient = selectedCard.requestBy ? selectedCard.requestBy : selectedCard.requestedBy;
      return Swal.fire({
        title: 'Are you sure?',
        html: `You are about to authorize ${$utils.formatMoney(selectedCard.amount)} payment to ${recipient}<br>
        <span class="text-sm text-primary">NB : This will not make the receivers account , just records the expense</span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async () => {
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Approved Successfully`);
            // GINGER-20260709 — #25497: refresh table view too
            return Promise.all([
              this.filterCards(),
              this.refillVueTable()
            ]); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Accept Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;
              return Swal.showValidationMessage('<pre>' + formattedError + '</pre>');
            }
          }
        }
      })
    },
    async viewPurchaseOrder(selectedCard) {
      const poNumber = selectedCard.purchaseOrder;
      return window.open(`https://tom9.pos.co.zm/PrintApi/creditor/burntofi_chrilan/printPurchaseOrder?id=${poNumber}&User=Auto`)
    },
    async openimage() {
      if (this.selectedCard) {
        const requestId = this.selectedCard.id; // Get the selected request ID
        const url = ticketApi2 + `getImageByRequestID/${requestId}`;

        try {
          const imageData = ticketApi2 + `getImageByRequestID/${requestId}`; // Assume this contains the image data or URL

          if (imageData) {
            // Show the image in a modal or other component
            Swal.fire({
              title: 'Attached Image',
              imageUrl: imageData, // Set the image URL or data
              confirmButtonText: 'OK'
            });
          } else {
            // Show a message if no image is attached
            Swal.fire({
              title: 'No Image Attached',
              text: 'Sorry, no images were attached to this request.',
              icon: 'info',
              confirmButtonText: 'OK'
            });
          }
        } catch (error) {
          return errorHandler.tomcatError(error)
        }
      } else {
        console.error('No card selected.');
        Swal.fire({
          title: 'Error!',
          text: 'Please select a request first.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    },
    async getLoggedInUser() {
      try {
        // `this.user` is still hydrated below — it's used elsewhere in this
        // component (approvedBy/declinedBy etc. need this.user.username).
        this.user = await Storage.getCurrentUser();
        // GINGER-20260711-DASHBOARD-MERCHANT-SELECTEDWALLET-FIX: After v1.4.29
        // wallet-endpoint swap, current_user.wallets comes from /getWallet/{id}
        // (per-user endpoint) which returns {api_key, wallet_name, primary} —
        // NO `id` field. The previous code read wallet.id from this.user.wallets,
        // so defaultWallet became undefined → filterCards() early-returned →
        // Dashboard showed no approvals for merchant AND balance (sourced from
        // /getWalletBalance/{selectedWallet}) showed K0.
        // Fix: fetch wallets from /get-all-wallets directly here (same source
        // Dashboard.vue:698 already uses for its own dropdown), which returns
        // wallets WITH the `id` field that getRequestsByWallet expects.
        let defaultWallet = null;
        const response = await axios.get(ticketApi2 + 'get-all-wallets');
        let wallets = response.data;
        if (wallets && wallets.length > 0) {
          let wallet = wallets.find(wal => wal.primary);
          if (wallet) {
            defaultWallet = wallet.id;
          } else {
            // EDWARD-20260708: Merchant (id=1) wallet from /get-all-wallets has no
            // `primary` flag (only that endpoint's per-user wallets do). Without
            // this fallback, defaultWallet stays null, selectedWallet stays null,
            // and filterCards' `if (this.selectedWallet)` early-returns → Dashboard
            // shows no approvals for the merchant despite current_user.wallets
            // being populated.
            defaultWallet = wallets[0].id;
          }
        }
        this.$store.commit(`setSelectedWallet`, defaultWallet);
        this.selectedWallet = defaultWallet;
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },
    async filterCards() {
      this.$utils.showLoading();

      if (this.isFetching) return; // Prevent multiple calls

      this.isFetching = true; // Set fetching flag

      try {
        if (this.selectedWallet) {
          const response = await axios.get(ticketApi2 + `getRequestsByWallet`, {
            params: {
              name: this.selectedWallet,
              department: this.selectedDepartment,
              office: this.selectedOffice,
            }
          });
          this.cardData.wallet = response.data.walletRequestResponses;
          this.cardData.user = response.data.userRequestResponseList;
          if (this.activeTab === 'wallet') {
            this.filteredCardData = this.cardData.wallet;
          } else {
            this.filteredCardData = this.cardData.user;
            console.log(this.filteredCardData);
          }
        } else {
          this.filteredCardData = [];
        }
        console.log(this.filteredCardData);
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.storeSelectedWallet();
        this.$utils.hideLoading();
        this.isFetching = false; // Reset fetching flag
      }
    },

    logNumber(number) {
      console.log(number);
    },

    async refillVueTable() {
      this.$utils.showLoading();

      if (this.isFetching) return; // Prevent multiple calls

      this.isFetching = true; // Set fetching flag

      try {
        if (this.selectedWallet) {
          const response = await axios.get(ticketApi2 + `getRequestsByWallet`, {
            params: {
              name: this.selectedWallet,
              department: this.selectedDepartment,
              office: this.selectedOffice,
            }
          });
          this.cardData.wallet = response.data.walletRequestResponses;
          this.cardData.user = response.data.userRequestResponseList;
          if (this.activeTab === 'wallet') {
            this.refillTableData = this.cardData.wallet;
          } else {
            this.refillTableData = this.cardData.user;
            this.refillTableData = this.refillTableData.map(obj => ({
              ...obj,
              massage: "", // flag
            }))
            console.log(this.refillTableData);
          }
        } else {
          this.refillTableData = [];
        }
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.storeSelectedWallet();
        this.$utils.hideLoading();
        this.isFetching = false; // Reset fetching flag
      }
    },
    async setTab(tab) {
      this.activeTab = tab;
      this.filterCards(); // Update cards based on selected tab
    },
    selectCard(item) {
      this.selectedCard = item;
      document.getElementById(`openCard`).click();
    },
    setFallbackImage(event) {
      event.target.src = '/img/no-image.png';
    },
  },
  watch: {
    selectedIds(newVal) {
      // Keep "Select All" checkbox in sync with individual selections
      this.selectAll =
          newVal.length === this.refillTableData.length &&
          this.refillTableData.length > 0;
    },
  },
  mounted() {
    this.filterCards();
    this.checkMobileView();
    window.addEventListener("resize", this.checkMobileView);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobileView);
  }
};
</script>
<style scoped lang="scss">
.flexy {
  display: flex;
  justify-content: center;
  align-items: center;
}
.manager {
  width: 100%;
  height: fit-content;
  border-radius: 5px;
  background-color: #1d90dd;
  color: white;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.h6-tag {
  margin-top: 5px;
  font-weight: 600;
}
.total {
  width: fit-content;
  display:flex;
  justify-content: center;
  align-items:center;
  gap: 10px
}
.form-container {
  position: relative;
}
.attention-required {
  color: #ff3c00;
  font-weight: bold;
  animation: flash 1s infinite;
}

@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
}

.hide {
  display: none;
}

.page {
  height: 85vh;
  overflow-y: scroll !important;
  overflow-X: hidden !important;
}

.hidden {
  display: none; /* This will hide the button completely */
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tabs {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.tabs button {
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f8f9fa;
  color: #333;
  padding: 0.5rem 1rem;
  margin-right: 1rem;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.tabs button.active {
  background-color: #007bff;
  color: white;
}

.modal-backdrop {
  z-index: -2 !important;
}


/*===== VARIABLES CSS =====*/
:root {
  --dark-color-lighten: #f2f5ff;
  --red-card: #a62121;
  --blue-card: #4bb7e6;
  --btn: #141414;
  --btn-hover: #3a3a3a;
  --text: #fbf7f7;
}

/*===== CARD =====*/
.container {
  width: 100%;
  max-width: 850px;
  margin: 2rem auto;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.card {
  position: relative;
  padding: 1rem;
  width: 300px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0.9rem;
  background-color: var(--red-card);
  color: var(--text);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s ease;
}

.card-blue {
  background: var(--blue-card);
}

.product-image {
  height: 140px;
  width: 100%;
  overflow: hidden;
  transform: translateY(0);
  transition: transform 500ms ease-in-out;
  filter: drop-shadow(5px 10px 15px rgba(0, 0, 0, 0.3));
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

.card:hover .product-image {
  transform: translateY(-10px) rotate(-3deg);
}

.product-info {
  text-align: center;
}

.product-info h2 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-info p {
  margin: 0.2rem 0;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price {
  font-size: 20px;
  font-weight: 600;
}

.card-body {
  text-align: left;
  font-size: 0.9rem;
  line-height: 1.4;
}

.btn {
  display: flex;
  justify-content: space-between;
  margin-top: 0.8rem;
}

.buy-btn {
  background-color: var(--btn);
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 1rem;
  transition: background-color 300ms ease;
}

.buy-btn:hover {
  background-color: var(--btn-hover);
}

.fav {
  background: #fff;
  padding: 0.5rem;
  border: 1px solid #000;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg {
  height: 25px;
  width: 25px;
  fill: #fff;
  transition: fill 500ms ease;
}

.fav:hover .svg {
  fill: #000;
}

@media screen and (max-width: 768px) {
  .total {
    width: fit-content;
    display:flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items:center;
    gap: 10px
  }
  .container {
    padding: 1rem;
    flex-direction: column;
  }

  .card {
    width: 90%;
  }

  .product-image {
    height: 150px;
  }
}

.row {
  margin-left: 12px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 5px;
  border-radius: 8px;
  text-align: center;
  width: 95%;
  max-width: 95%;
  max-height: 99vh;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.modal-bodyy {
  flex: 1; /* Makes the body take up remaining space */
  overflow-y: auto; /* Enables vertical scrolling */
  padding: 1rem;
  width: 100%;
}
.modal-header {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.div-class {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 400px;
  height: 100px;
  background: aliceblue;
  margin-bottom: 10px;
}

.img {
  width: 40px;
  height: 40px;
}
.card-container {
  width: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);  /* Semi-transparent overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;  /* Ensure it covers the form */
  pointer-events: all;  /* Block interactions */
}
.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }

  50% {
    transform: scale(1.2);
    background-color: #6793fb;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }

  100% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}

.filter {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


